// Contentful
import { orDefaultPriority } from '../../helpers/contentful';

// Components
import CaseItem from '../CaseItem/CaseItem';

const CasesGrid = (props) => {
  const { cases } = props;
  const sorted = cases.sort((a, b) => orDefaultPriority(a.fields.priority) - orDefaultPriority(b.fields.priority));

  return (
    <div className="CasesGrid">
      <div className="CasesGrid-inner">
        <div className="CasesGrid-items">
          {sorted.map((item, index) => (
            <CaseItem key={`CaseItem-${index}`} {...item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CasesGrid;
